












































































  import SectionHeader from "../SectionHeader.vue";
  import {Component, Vue} from 'vue-property-decorator';
  import Editor from './Editor.vue'
  import * as monaco from 'monaco-editor';
  import {curCoreClient, CoreClient} from '@/services/CoreClient';
  import Loading from "@/components/Loading.vue";
  import EnterpriseId from "@/components/EnterpriseId.vue";
  import VueError from "@/components/VueError.vue"
  import tippy from "tippy.js";
  import { Info } from '../../types/core';

  @Component({
    components: {
      EnterpriseId,
      SectionHeader,
      Editor,
      Loading,
      VueError
    }
  })
  export default class LoraParserNew extends Vue {

    name = '';
    markers: monaco.editor.IMarker[] = [];
    info:Info = {} as Info;
    enterpriseId:string = '';
    httpBusy:boolean = false;
    errorMsg = '';


    code = `function parseDeviceMsg(buf:Buffer, loraMsg:LoraMessage):ParserReading[] {
  
  let retList:ParserReading[] = [];

  // TODO: insert your code here

  return retList
}`;

    private coreClient:CoreClient = curCoreClient;

    async mounted() {

      tippy('[data-tippy-content]')

      let info = await this.coreClient.getInfo()

      if(info.httpCode === 403)
        return this.$router.push({name:'login'});

      if(info.errorMsg)
        return this.errorMsg = `Unable to retrieve user info: ${info.errorMsg}`
      
      this.info = info.info!;
    }

    updateMarkers(markers:monaco.editor.IMarker[]){
      this.markers = markers
    }

    onMouseOut(event:any, validate:() => void) {
      // compares whether the element the mouse has left matches the active element
      if (event.fromElement === document.activeElement) {
        validate()
      }
      return;
    }

    async saveLoraParser(){
      const body = {
        name: this.name,
        enterpriseId: this.enterpriseId,
        codeJs: this.code
      };

      this.httpBusy = true;
      this.errorMsg = "";

      let reply = await this.coreClient.createLoraParser(body)

      this.httpBusy = false;

      if(reply.httpCode === 403){
        return this.$router.push({name:'login'});
      }

      if(reply.errorMsg){
        this.errorMsg = `Unable to update: ${reply.errorMsg}`;
        return;
      }

      this.$router.push({name:'lora-parser-list'})
    }

    cancel(){
      this.$router.push({name:'lora-parser-list'})
    }

    get canSave(){
      const markerErrors = this.markers.filter(m => m.severity === monaco.MarkerSeverity.Error).length > 0;
      return !markerErrors
    }

    get canCancel() {
      return !this.httpBusy;
    }

  }
